/**
 * تطبيق الحسابات's page shell for the build and the service worker (vite.config.ts), kept free of the app's imports
 * and the DOM, like features/operations/opsHtml.ts.
 */
export const ACCOUNTS_MANIFEST = '/accounts.webmanifest'
export const ACCOUNTS_TITLE = 'Aliens Finance'

/** accounts.html, made from the built index.html: the manifest is right before any script runs (iPhone "Add to Home"). */
export function accountsHtml(index: string) {
  return index
    .replace(/href="\/manifest\.webmanifest"/, `href="${ACCOUNTS_MANIFEST}"`)
    .replace(/<title>[^<]*<\/title>/, `<title>${ACCOUNTS_TITLE}</title>`)
    .replace('<meta name="apple-mobile-web-app-capable" content="yes" />', `<meta name="apple-mobile-web-app-capable" content="yes" />\n    <meta name="apple-mobile-web-app-title" content="${ACCOUNTS_TITLE}" />`)
}

/** An /accounts-app page with no internet, never opened before: the precached accounts.html (runs in the worker). */
export async function accountsShellFromPrecache(): Promise<Response | undefined> {
  return (await globalThis.caches?.match('/accounts.html', { ignoreSearch: true })) ?? undefined
}
